// extracted by mini-css-extract-plugin
export default {"nextIcon":"styles_nextIcon__9xrOf","previousIcon":"styles_previousIcon__twtC7"};